module.exports = __webpack_public_path__ + "static/media/analytic-904.afd9c6d3.png";